import { Link, Navigate, useParams } from "react-router-dom";
import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import { RECRUIT_CATEGORIES } from "@/constants/site";

export default function RecruitCategoryPage() {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  const category = RECRUIT_CATEGORIES.find((item) => item.slug === categorySlug);

  if (!category) {
    return <Navigate to="/recruit" replace />;
  }

  return (
    <div className="w-full bg-background-50">
      <PageHero
        en={category.en.toUpperCase()}
        ja={category.title}
        crumbs={[{ label: "採用情報", path: "/recruit" }, { label: category.title }]}
      />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label={category.title} en="Openings" />
            <p className="mt-6 max-w-2xl font-body text-[15px] leading-[2] text-foreground-700">
              {category.desc}
            </p>
          </ScrollReveal>

          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8">
            {category.jobs.map((job, index) => (
              <ScrollReveal key={job.slug} delay={index * 100}>
                <Link
                  to={`/recruit/${category.slug}/${job.slug}`}
                  className="group flex h-full flex-col border border-background-300/70 bg-background-50 p-8 shadow-sm transition-shadow duration-300 hover:shadow-lg md:p-10"
                >
                  <span className="font-label text-xs tracking-[0.24em] text-secondary-500">
                    {job.en.toUpperCase()}
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-medium tracking-[0.04em] text-foreground-950">
                    {job.title}
                  </h3>
                  <p className="mt-4 flex-1 font-body text-sm leading-[2] text-foreground-700">
                    {job.summary}
                  </p>
                  <span className="mt-8 inline-flex items-center gap-2 font-label text-xs tracking-[0.24em] text-foreground-950 transition-colors group-hover:text-accent-700">
                    募集要項を見る
                    <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={200}>
            <div className="mt-14 flex justify-center">
              <Link
                to="/recruit"
                className="inline-flex items-center gap-3 whitespace-nowrap border border-foreground-950 px-9 py-3.5 font-body text-[12px] tracking-[0.22em] text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
              >
                <i className="ri-arrow-left-line" />
                募集職種一覧に戻る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
